import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ModalComponent from "../../biblio/Modal/ModalComponent";
import nationalDayImage from "../../assets/images/national_day_image.jpeg";

const NationalDayModal = () => {
  const { pathname } = useLocation();

  const isNationalDay = pathname === "/national_day=true";

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isNationalDay);
  }, [isNationalDay]);

  if (!isNationalDay) return null;

  return (
    <ModalComponent
      title=""
      open={open}
      onClose={() => setOpen(false)}
      closeOnOutsideClick
      centered
      width={600}
      modalStyle={{ top: 0, height: "auto", minHeight: "auto" }}
      className="takaful--national-day-modal"
      destroyOnClose
    >
      <img
        src={nationalDayImage}
        alt=""
        className="takaful--national-day-modal-image"
      />
    </ModalComponent>
  );
};

export default NationalDayModal;
